import { TransactionDetails } from '@verantos-dev/types-common';

export enum CohortCharacteristicsResultType {
  ETHNICITY = 'ethnicity',
  GENDER = 'gender',
  RACE = 'race',
  AGE_AT_INDEX = 'ageAtIndex',
  EVENT_DISTRIBUTION = 'eventDistribution',
  KPI = 'kpi',
  CC_CONDITION = 'ccCondition',
  CC_DRUG = 'ccDrug',
  CC_MEASUREMENT = 'ccMeasurement',
  CC_OBSERVATION = 'ccObservation',
  CC_PROCEDURE = 'ccProcedure',
  CC_VISIT = 'ccVisit',
}

export type CohortSummaryAttributeResult = {
  attributeName: string;
  attributeCount: number;
  attributePercentage: number;
};

export type DomainType =
  | CohortCharacteristicsResultType.CC_CONDITION
  | CohortCharacteristicsResultType.CC_DRUG
  | CohortCharacteristicsResultType.CC_MEASUREMENT
  | CohortCharacteristicsResultType.CC_OBSERVATION
  | CohortCharacteristicsResultType.CC_PROCEDURE
  | CohortCharacteristicsResultType.CC_VISIT;

export type CohortCharacteristicsResults = {
  [key in CohortCharacteristicsResultType]: CohortSummaryAttributeResult[];
};

export interface CohortSummaryDetails extends TransactionDetails, CohortCharacteristicsResults {
  cohortDefinitionId: string;
}
